import React, { FunctionComponent, useMemo } from "react";
import { Node } from "@iventis/domain-model/model/node";
import { TreeBrowserDomainNodeContext, findNodes, useTreeBrowser } from "@iventis/tree-browser";
import { DeleteNodesConfirmationComponent } from "../plan-library/delete-nodes-confirmation";

interface DeleteNodeProps {
    onConfirm: (nodes: Node[]) => void;
    onClose: () => void;
}

/**
 * Wrapper for delete node modal to be used inside sidebar nodes
 */
export const DeleteNodeModal: FunctionComponent<DeleteNodeProps> = ({ onClose, onConfirm }) => {
    const [{ tree, selectedNodeIds }] = useTreeBrowser(TreeBrowserDomainNodeContext, null, "tree", "selectedNodeIds");

    const selectedNodes = useMemo(() => findNodes([tree], selectedNodeIds), [selectedNodeIds]);

    return <DeleteNodesConfirmationComponent modalLocation="map" nodes={selectedNodes} onConfirm={() => onConfirm(selectedNodes)} onClose={onClose} show />;
};
